// import React, {
//   useCallback,
//   useEffect,
//   useMemo,
//   useRef,
//   useState,
// } from "react";
// import { Transition } from "@headlessui/react";
// import {
//   editProfile,
//   fetchUserProfile,
//   getBankList,
//   getCountryList,
//   getNonNigerianBanksList,
//   updatebBank,
//   updateSocial,
// } from "../../../api-client/profile";
// import { useCookies } from "react-cookie";
// import { useQuery } from "react-query";
// import { toast } from "react-toastify";
// import { DashCard } from "../card";
// import { EditInput } from "../input";

// import {
//   AddBankModal,
//   CountryModal,
//   NonNigerianBankModal,
// } from "../../widgets/modals/select-modal";
// import Button from "../button";
// // import Button from "../../sections/profile/Button";

// const Sidebar = () => {
//   const [open, setOpen] = useState(false);

//   const [socialUpdateLoading, setUpdateSocialLoading] = useState(false);
//   const [loading, setLoading] = useState();
//   const [updateBankLoading, setUpdateBankLoading] = useState(false);
//   const [email, setEmail] = useState("");
//   const [cookie, setCookie] = useCookies();
//   const [_banks, setBanks] = useState([]);
//   const [_mobileMoney, setMobileMoney] = useState([]);
//   const [profileEditMode, setProfileEditMode] = useState(false);

//   const { data: _countryList, isCountryLoading } = useQuery(
//     ["country-list"],
//     getCountryList
//   );

//   const getBank = async () => {
//     try {
//       const res = await getBankList();
//       setBanks(res.data.data);
//     } catch (error) {
//       toast.error(error.response.data.message);
//     }
//   };

//   const getNonNigerianBanks = async () => {
//     try {
//       const res = await getNonNigerianBanksList();
//       setMobileMoney(res.data.data);
//     } catch (error) {
//       toast.error(error.response.data.message);
//     }
//   };

//   const [addBankModal, setAddBankModal] = useState(false);
//   const [selectCountryModal, setSelectCountryModal] = useState(false);
//   const [nonNigerianBankModal, setNonNigerianBankModal] = useState(false);
//   const [selectedBank, setSelectedBank] = useState("");
//   const [bankCode, setBankCode] = useState("");
//   const [selectedCountry, setSelectedCountry] = useState("");

//   const [countryValue, setCountryValue] = useState("");
//   // input State
//   const [firstName, setFirstName] = useState("");
//   const [lastName, setLastName] = useState("");
//   const [phone, setPhone] = useState("");
//   const [phone2, setPhone2] = useState("");
//   const [country, setCountry] = useState("");
//   const [accountNumber, setAccountNumber] = useState("");
//   const [accountNo, setAccountNo] = useState("");
//   const [twitter, setTwitter] = useState("");
//   const [instagram, setInstagram] = useState("");
//   const [tiktok, setTiktok] = useState("");
//   const [facebook, setFacebook] = useState("");
//   const [bankName, setBankName] = useState("");
//   const [accountName, setAccountName] = useState("");
//   const [nonNgBankAccountName, setNonNgBankAccountName] = useState("");

//   const [firstNameFocus, setFirstNameFocus] = useState(false);
//   const [lastNameFocus, setLastNameFocus] = useState(false);
//   const [phoneFocus, setPhoneFocus] = useState(false);
//   const [phone2Focus, setPhone2Focus] = useState(false);

//   const [twitterFocus, setTwitterFocus] = useState(false);
//   const [instagramFocus, setInstagramFocus] = useState(false);
//   const [tiktokFocus, setTiktokFocus] = useState(false);
//   const [facebookFocus, setFacebookFocus] = useState(false);

//   const [firstNameUpdateBtn, setfirstNameUpdateBtn] = useState(false);
//   const [lastNameUpdateBtn, setlastNameUpdateBtn] = useState(false);
//   const [phoneUpdateBtn, setphoneUpdateBtn] = useState(false);
//   const [phone2UpdateBtn, setphone2UpdateBtn] = useState(false);
//   const [countryUpdateBtn, setcountryUpdateBtn] = useState(false);
//   const [passwordUpdateBtn, setpasswordUpdateBtn] = useState(false);
//   const [accountNumberUpdateBtn, setaccountNumberUpdateBtn] = useState(false);
//   const [twitterUpdateBtn, settwitterUpdateBtn] = useState(false);
//   const [instagramUpdateBtn, setinstagramUpdateBtn] = useState(false);
//   const [facebookUpdateBtn, setFacebookUpdateBtn] = useState(false);
//   const [tiktokUpdateBtn, setTiktokUpdateBtn] = useState(false);

//   const level = useMemo(() => cookie?.user?.userData[0]?.level, [cookie]);
//   const banks = useMemo(
//     () =>
//       _banks.map((val) => ({
//         label: val.name,
//         value: val.code,
//       })),
//     [_banks]
//   );

//   const countryList = useMemo(
//     () =>
//       _countryList?.data?.data.map((val) => ({
//         label: val.name,
//         value: val.code,
//       })),
//     [_countryList]
//   );

//   const mobileMoney = useMemo(
//     () =>
//       _mobileMoney?.map((val) => ({
//         label: val.bankName,
//         value: val.bankCode,
//       })),
//     [_mobileMoney]
//   );

//   // Create Reference for All fields
//   const firstNameRef = useRef();
//   const lastNameRef = useRef();
//   const phoneRef = useRef();
//   const phone2Ref = useRef();
//   const passwordRef = useRef();
//   const accountNumberRef = useRef();
//   const twitterRef = useRef();
//   const instagramRef = useRef();
//   const emailRef = useRef();
//   const countryRef = useRef();
//   const tiktokRef = useRef();
//   const facebookRef = useRef();

//   // Get User
//   const getUser = async () => {
//     setLoading(true);
//     try {
//       const res = await fetchUserProfile();
//       const { user, profile } = res?.data?.data;
//       setFirstName(user?.firstName);
//       setLastName(user?.lastName);
//       setPhone(user?.phone);
//       setPhone2(user?.phone2);
//       setEmail(user?.email);
//       setCountry(user?.country);
//       setAccountNumber(profile?.accountNumber);
//       setBankName(profile?.bankName);
//       setAccountName(profile?.accountName);
//       setTwitter(profile?.twitter);
//       setInstagram(profile?.instagram);
//       setFacebook(profile?.facebook);
//       setTiktok(profile?.tiktok);

//       setLoading(false);
//     } catch (error) {
//       setLoading(false);
//     }
//   };

//   const updateSocialMedia = async () => {
//     setUpdateSocialLoading(true);

//     const data = {
//       twitter,
//       instagram,
//       tiktok,
//       facebook,
//     };

//     try {
//       const res = await updateSocial(data);
//       setUpdateSocialLoading(false);
//       toast.success(res.data.message);
//       setTwitterFocus(false);
//       setInstagramFocus(false);
//       setTiktokFocus(false);
//       setInstagramFocus(false);
//     } catch (error) {
//       setUpdateSocialLoading(false);
//       toast.error("Something went wrong! Please try Again");
//     }
//   };

//   // Update Profile Details
//   const updateProfile = async () => {
//     setLoading(true);

//     const data = {
//       firstName,
//       lastName,
//       phone,
//       phone2,
//       country: selectedCountry,
//     };

//     try {
//       const res = await editProfile(data);
//       setLoading(false);
//       setFirstNameFocus(false);
//       setLastNameFocus(false);
//       setPhoneFocus(false);
//       setPhone2Focus(false);
//       setSelectCountryModal(false);

//       setFirstName(res?.data?.data?.firstName);
//       setLastName(res?.data?.data?.lastName);
//       setPhone(res?.data?.data?.phone);
//       setPhone2(res?.data?.data?.phone2);
//       setCountry(res?.data?.data?.country);

//       toast.success(res.data.message);
//     } catch (error) {
//       setLoading(false);
//       toast.error(error.response.data.message);
//     }
//   };

//   // Update Bank Details
//   const updateBank = useCallback(async () => {
//     setUpdateBankLoading(true);
//     const data = {
//       bankName: selectedBank,
//       bankCode,
//       accountNumber: accountNo?.replace(/[^a-zA-Z0-9 ]/g, ""),
//       accountName: nonNgBankAccountName,
//     };

//     try {
//       const res = await updatebBank(data);
//       toast.success(res.data.message);
//       setAddBankModal(false);
//       setNonNigerianBankModal(false);
//       setUpdateBankLoading(false);

//       setAccountName(res?.data?.data?.accountName);
//       setAccountNumber(res?.data?.data.accountNumber);
//       setBankName(res?.data?.data?.bankName);
//     } catch (error) {
//       setLoading(false);
//       toast.error("Invalid Bank Details!, Please try Again!");
//       setUpdateBankLoading(false);
//     }
//   }, [selectedBank, bankCode, accountNo, nonNgBankAccountName]);

//   useEffect(() => {
//     getUser();
//   }, []);

//   useEffect(() => {
//     // This effect is used to handle any side effects when the sidebar is opened or closed
//   }, [open]);

//   return (
//     <>
//       {addBankModal && (
//         <AddBankModal
//           setAddBankModal={setAddBankModal}
//           options={banks}
//           selectedInput={selectedBank}
//           setSelectedInput={setSelectedBank}
//           loading={updateBankLoading}
//           updateBank={updateBank}
//           accountNumber={accountNumber}
//           accountNo={accountNo}
//           setAccountNo={setAccountNo}
//           setAccountNumber={setAccountNumber}
//           value={bankCode}
//           setValue={setBankCode}
//         />
//       )}
//       {nonNigerianBankModal && (
//         <NonNigerianBankModal
//           setNonNigerianBankModal={setNonNigerianBankModal}
//           options={mobileMoney}
//           selectedInput={selectedBank}
//           setSelectedInput={setSelectedBank}
//           loading={updateBankLoading}
//           updateBank={updateBank}
//           accountNumber={accountNumber}
//           accountNo={accountNo}
//           accountName={nonNgBankAccountName}
//           setAccountName={setNonNgBankAccountName}
//           setAccountNo={setAccountNo}
//           setAccountNumber={setAccountNumber}
//           value={bankCode}
//           setValue={setBankCode}
//         />
//       )}
//       {selectCountryModal && (
//         <CountryModal
//           loading={loading}
//           setSelectCountryModal={setSelectCountryModal}
//           options={countryList}
//           selectedInput={selectedCountry}
//           setSelectedInput={setSelectedCountry}
//           updateProfile={updateProfile}
//           value={countryValue}
//           setValue={setCountryValue}
//         />
//       )}
//       <div className="flex justify-center items-center ">
//         <div>
//           <section className="absolute inset-y-0 right-0 pl-10 max-w-full flex">
//             <Transition
//               show={open}
//               enter="transition-transform ease-out duration-300"
//               enterFrom="transform translate-x-full"
//               enterTo="transform translate-x-0"
//               leave="transition-transform ease-in duration-300"
//               leaveFrom="transform translate-x-0"
//               leaveTo="transform translate-x-full"
//               className="w-screen max-w-2xl h-screen"
//             >
//               <div className="h-screen flex flex-col py-6 bg-white shadow-xl ">
//                 {/* Sidebar Header */}
//                 <div className="flex items-center justify-between px-4 my-3 py-3">
//                   <div className="flex  flex-col">
//                     <h2 className="text-[22px] text-[#205363] font-semibold ">
//                       Edit Personal Information
//                     </h2>
//                     <h2 className="text-[12px] text-gray-400 leading-[16px]  ">
//                       Adjust Your personal information and keep it updated
//                     </h2>
//                   </div>
//                   <button
//                     onClick={() => setOpen(false)}
//                     className="text-gray-500 flex items-center hover:text-gray-700 border-2 rounded-[8px] py-3 px-3"
//                   >
//                     <span className=" text-black mx-2">Close</span>
//                     <svg
//                       className="h-6 w-6 border-[1px] rounded-full"
//                       xmlns="http://www.w3.org/2000/svg"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                       aria-hidden="true"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M6 18L18 6M6 6l12 12"
//                       />
//                     </svg>
//                   </button>
//                 </div>
//                 {/* Search Input */}
//                 {/* <div className="mt-4 px-4">
//                   <input
//                     type="text"
//                     placeholder="Search post here"
//                     className="w-full p-2 border border-gray-300 rounded-md focus:border-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 transition-colors duration-300"
//                   />
//                 </div>
//                 <div className="mt-4 px-4">
//                   <p className="ml-2 text-gray-400">Results</p>
//                 </div> */}
//                 {/* Sidebar Content */}
//                 <div className="mt-4 px-4 h-screen  z-1">
//                   <div className="mt-6">
//                     <section className="flex flex-col   mb-9">
//                       <div>
//                         <h4 className="text-neutral-light-50 mb-2">
//                           First Name
//                         </h4>
//                         <EditInput
//                           value={firstName}
//                           onChange={(e) => setFirstName(e.target.value)}
//                           placeholder="Edit First Name"
//                           inputRef={firstNameRef}
//                           onFocus={() => setFirstNameFocus(true)}
//                         />
//                       </div>
//                       <div className="w-full">
//                         <Button
//                           className="w-full py-[13px] bg-primary-p300 text-left text-light"
//                           onClick={async () =>
//                             firstNameFocus
//                               ? await updateProfile()
//                               : firstNameRef.current.focus()
//                           }
//                           label={firstNameFocus ? "Update" : "Edit"}
//                         />
//                       </div>
//                     </section>
//                     <section className="flex flex-col   mb-9">
//                       <div>
//                         <h4 className="text-neutral-light-50 mb-2">
//                           Last Name
//                         </h4>
//                         <EditInput
//                           value={lastName}
//                           onChange={(e) => setLastName(e.target.value)}
//                           placeholder="Edit Last Name"
//                           inputRef={lastNameRef}
//                           onFocus={() => setLastNameFocus(true)}
//                           // onBlur={() => setLastNameFocus(false)}
//                         />
//                       </div>

//                       <div className="w-full">
//                         <Button
//                           className="w-full py-[13px] bg-primary-p300 text-light"
//                           onClick={async () =>
//                             lastNameFocus
//                               ? await updateProfile()
//                               : lastNameRef.current.focus()
//                           }
//                           label={lastNameFocus ? "Update" : "Edit"}
//                         />
//                       </div>
//                     </section>

//                     <section className="flex flex-col   mb-9">
//                       <div>
//                         <h4 className="text-neutral-light-50 mb-2">Email</h4>
//                         <h3>{email}</h3>
//                       </div>
//                       <div></div>
//                     </section>
//                     <section className="flex flex-col   mb-9">
//                       <div>
//                         <h4 className="text-neutral-light-50 mb-2">
//                           Phone Number (Primary)
//                         </h4>
//                         <EditInput
//                           value={phone}
//                           onChange={(e) => setPhone(e.target.value)}
//                           placeholder="Edit Phone Number"
//                           inputRef={phoneRef}
//                           onFocus={() => setPhoneFocus(true)}
//                         />
//                       </div>
//                       <div className="w-full">
//                         <Button
//                           className="w-full py-[13px] bg-primary-p300 text-light"
//                           onClick={async () => {
//                             phoneFocus
//                               ? await updateProfile()
//                               : phoneRef.current.focus();
//                           }}
//                           label={phoneFocus ? "Update" : "Edit"}
//                         />
//                       </div>
//                     </section>
//                     <section className="flex flex-col   mb-9">
//                       <div>
//                         <h4 className="text-neutral-light-50 mb-2">
//                           Phone Number (Secondary)
//                         </h4>

//                         <EditInput
//                           value={phone2}
//                           onChange={(e) => setPhone2(e.target.value)}
//                           placeholder="Edit Phone Number 2"
//                           inputRef={phone2Ref}
//                           onFocus={() => setPhone2Focus(true)}
//                         />
//                       </div>
//                       <div className="w-full">
//                         <Button
//                           className="w-full py-[13px] bg-primary-p300 text-light"
//                           onClick={async () => {
//                             phone2Focus
//                               ? await updateProfile()
//                               : phone2Ref.current.focus();
//                           }}
//                           label={phone2Focus ? "Update" : "Edit"}
//                         />
//                       </div>
//                     </section>
//                   </div>
//                 </div>
//               </div>
//             </Transition>
//           </section>
//           {/* Open sidebar button */}
//           <button
//             onClick={() => setOpen(true)}
//             className="px-8 py-3 border-[2px] text-[#205363] w-[144px] h-[36px] leading-[16px] text-[16px]  rounded-md font-bold border-[#205363]"
//           >
//             Edit
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Sidebar;

import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Transition } from "@headlessui/react";
import {
  editProfile,
  fetchUserProfile,
  getBankList,
  getCountryList,
  getNonNigerianBanksList,
  updatebBank,
  updateSocial,
} from "../../../api-client/profile";
import { useCookies } from "react-cookie";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { DashCard } from "../card";
import { EditInput } from "../input";

import {
  AddBankModal,
  CountryModal,
  NonNigerianBankModal,
} from "../../widgets/modals/select-modal";
import Button from "../button";

const updateProfile = async () => {
  setLoading(true);

  const data = {
    firstName,
    lastName,
    phone,
    phone2,
    country: selectedCountry,
  };

  try {
    const res = await editProfile(data);
    setLoading(false);
    setFirstNameFocus(false);
    setLastNameFocus(false);
    setPhoneFocus(false);
    setPhone2Focus(false);
    setSelectCountryModal(false);

    setFirstName(res?.data?.data?.firstName);
    setLastName(res?.data?.data?.lastName);
    setPhone(res?.data?.data?.phone);
    setPhone2(res?.data?.data?.phone2);
    setCountry(res?.data?.data?.country);

    toast.success(res.data.message);
  } catch (error) {
    setLoading(false);
    toast.error(error.response.data.message);
  }
};
const SocialSideBar = () => {
  const [open, setOpen] = useState(false);

  const [socialUpdateLoading, setUpdateSocialLoading] = useState(false);
  const [loading, setLoading] = useState();
  const [updateBankLoading, setUpdateBankLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [cookie, setCookie] = useCookies();
  const [_banks, setBanks] = useState([]);
  const [_mobileMoney, setMobileMoney] = useState([]);
  const [profileEditMode, setProfileEditMode] = useState(false);

  const { data: _countryList, isCountryLoading } = useQuery(
    ["country-list"],
    getCountryList
  );

  const getBank = async () => {
    try {
      const res = await getBankList();
      setBanks(res.data.data);
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const getNonNigerianBanks = async () => {
    try {
      const res = await getNonNigerianBanksList();
      setMobileMoney(res.data.data);
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const [addBankModal, setAddBankModal] = useState(false);
  const [selectCountryModal, setSelectCountryModal] = useState(false);
  const [nonNigerianBankModal, setNonNigerianBankModal] = useState(false);
  const [selectedBank, setSelectedBank] = useState("");
  const [bankCode, setBankCode] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");

  const [countryValue, setCountryValue] = useState("");
  // input State
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [phone2, setPhone2] = useState("");
  const [country, setCountry] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountNo, setAccountNo] = useState("");
  const [twitter, setTwitter] = useState("");
  const [instagram, setInstagram] = useState("");
  const [tiktok, setTiktok] = useState("");
  const [facebook, setFacebook] = useState("");
  const [bankName, setBankName] = useState("");
  const [accountName, setAccountName] = useState("");
  const [nonNgBankAccountName, setNonNgBankAccountName] = useState("");

  const [firstNameFocus, setFirstNameFocus] = useState(false);
  const [lastNameFocus, setLastNameFocus] = useState(false);
  const [phoneFocus, setPhoneFocus] = useState(false);
  const [phone2Focus, setPhone2Focus] = useState(false);

  const [twitterFocus, setTwitterFocus] = useState(false);
  const [instagramFocus, setInstagramFocus] = useState(false);
  const [tiktokFocus, setTiktokFocus] = useState(false);
  const [facebookFocus, setFacebookFocus] = useState(false);

  const [updateBtnLoading, setUpdateBtnLoading] = useState(false);

  const level = useMemo(() => cookie?.user?.userData[0]?.level, [cookie]);
  const banks = useMemo(
    () =>
      _banks.map((val) => ({
        label: val.name,
        value: val.code,
      })),
    [_banks]
  );

  const countryList = useMemo(
    () =>
      _countryList?.data?.data.map((val) => ({
        label: val.name,
        value: val.code,
      })),
    [_countryList]
  );

  const mobileMoney = useMemo(
    () =>
      _mobileMoney?.map((val) => ({
        label: val.bankName,
        value: val.bankCode,
      })),
    [_mobileMoney]
  );

  const updateProfile = async () => {
    setLoading(true);
    const data = {
      firstName,
      lastName,
      phone,
      phone2,
      country: selectedCountry,
    };

    try {
      const res = await editProfile(data);
      setFirstName(res.data.data.firstName);
      setLastName(res.data.data.lastName);
      setPhone(res.data.data.phone);
      setPhone2(res.data.data.phone2);
      setCountry(res.data.data.country);
      toast.success(res.data.message);
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const updateSocialMedia = async () => {
    setUpdateSocialLoading(true);
    const data = { twitter, instagram, tiktok, facebook };

    try {
      const res = await updateSocial(data);
      toast.success(res.data.message);
    } catch (error) {
      toast.error("Something went wrong! Please try again.");
    } finally {
      setUpdateSocialLoading(false);
    }
  };

  const updateBankDetails = async () => {
    setUpdateBankLoading(true);
    const data = {
      bankName: selectedBank,
      bankCode,
      accountNumber: accountNo?.replace(/[^a-zA-Z0-9 ]/g, ""),
      accountName: nonNgBankAccountName,
    };

    try {
      const res = await updateBank(data);
      setAccountName(res.data.data.accountName);
      setAccountNumber(res.data.data.accountNumber);
      setBankName(res.data.data.bankName);
      toast.success(res.data.message);
    } catch (error) {
      toast.error("Invalid Bank Details! Please try again.");
    } finally {
      setUpdateBankLoading(false);
    }
  };

  // Create Reference for All fields
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const phoneRef = useRef();
  const phone2Ref = useRef();
  const passwordRef = useRef();
  const accountNumberRef = useRef();
  const twitterRef = useRef();
  const instagramRef = useRef();
  const emailRef = useRef();
  const countryRef = useRef();
  const tiktokRef = useRef();
  const facebookRef = useRef();

  // Get User
  const getUser = async () => {
    setLoading(true);
    try {
      const res = await fetchUserProfile();
      const { user, profile } = res?.data?.data;
      setFirstName(user?.firstName);
      setLastName(user?.lastName);
      setPhone(user?.phone);
      setPhone2(user?.phone2);
      setEmail(user?.email);
      setCountry(user?.country);
      setAccountNumber(profile?.accountNumber);
      setBankName(profile?.bankName);
      setAccountName(profile?.accountName);
      setTwitter(profile?.twitter);
      setInstagram(profile?.instagram);
      setFacebook(profile?.facebook);
      setTiktok(profile?.tiktok);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    setUpdateBtnLoading(true);

    const data = {
      firstName,
      lastName,
      phone,
      phone2,
      country: selectedCountry,
      twitter,
      instagram,
      tiktok,
      facebook,
    };

    try {
      const res = await editProfile(data);
      setLoading(false);
      setFirstNameFocus(false);
      setLastNameFocus(false);
      setPhoneFocus(false);
      setPhone2Focus(false);
      setTwitterFocus(false);
      setInstagramFocus(false);
      setTiktokFocus(false);
      setFacebookFocus(false);
      setSelectCountryModal(false);

      setFirstName(res?.data?.data?.firstName);
      setLastName(res?.data?.data?.lastName);
      setPhone(res?.data?.data?.phone);
      setPhone2(res?.data?.data?.phone2);
      setCountry(res?.data?.data?.country);
      setTwitter(res?.data?.data?.twitter);
      setInstagram(res?.data?.data?.instagram);
      setFacebook(res?.data?.data?.facebook);
      setTiktok(res?.data?.data?.tiktok);

      toast.success(res.data.message);
    } catch (error) {
      setUpdateBtnLoading(false);
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  useEffect(() => {
    // This effect is used to handle any side effects when the sidebar is opened or closed
  }, [open]);

  return (
    <>
      {addBankModal && (
        <AddBankModal
          setAddBankModal={setAddBankModal}
          options={banks}
          selectedInput={selectedBank}
          setSelectedInput={setSelectedBank}
          loading={updateBankLoading}
          updateBank={updateBank}
          accountNumber={accountNumber}
          accountNo={accountNo}
          setAccountNo={setAccountNo}
          setAccountNumber={setAccountNumber}
          value={bankCode}
          setValue={setBankCode}
        />
      )}
      {nonNigerianBankModal && (
        <NonNigerianBankModal
          setNonNigerianBankModal={setNonNigerianBankModal}
          options={mobileMoney}
          selectedInput={selectedBank}
          setSelectedInput={setSelectedBank}
          loading={updateBankLoading}
          updateBank={updateBank}
          accountNumber={accountNumber}
          accountNo={accountNo}
          accountName={nonNgBankAccountName}
          setAccountName={setNonNgBankAccountName}
          setAccountNo={setAccountNo}
          setAccountNumber={setAccountNumber}
          value={bankCode}
          setValue={setBankCode}
        />
      )}
      {selectCountryModal && (
        <CountryModal
          loading={loading}
          setSelectCountryModal={setSelectCountryModal}
          options={countryList}
          selectedInput={selectedCountry}
          setSelectedInput={setSelectedCountry}
          updateProfile={updateProfile}
          value={countryValue}
          setValue={setCountryValue}
        />
      )}
      <div className="flex justify-center items-center ">
        <div>
          <Transition
            show={open}
            enter="transition-opacity ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-in duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            className="fixed inset-0  overflow-hidden z-[0]"
          >
            <div className="absolute inset-0 bg-[#205363] bg-opacity-75 transition-opacity"></div>
          </Transition>
          <section className="absolute inset-y-0 right-0 lg:pl-10 max-w-full flex h-[100vh]">
            <Transition
              show={open}
              enter="transition-transform ease-out duration-300"
              enterFrom="transform translate-x-full"
              enterTo="transform translate-x-0"
              leave="transition-transform ease-in duration-300"
              leaveFrom="transform translate-x-0"
              leaveTo="transform translate-x-full"
              // className="w-screen max-w-xl rounded-l-[24px] h-screen mt-5 mb-10"
              className="w-screen  max-w-2xl lg:max-w-2xl  lg:m-7 m-2 lg:mr-9 mr-1 relative "
            >
              <div
                className=" flex flex-col h-screen py-6 bg-white rounded-[24px] p-2 lg:p-5 relative border-4  "
                style={{ height: "100vh" }}
              >
                {/* Sidebar Header */}
                <div className="flex items-center justify-between px-4  m-3 pt-8 pb-10 border-b-[1px] ">
                  <div className="flex  flex-col">
                    <h2 className="lg:text-[22px] text-[12px] text-[#205363] font-[600] ">
                      Edit Social Information
                    </h2>
                    <h2 className="text-[12px] text-gray-400 leading-[16px]  ">
                      Adjust Your Social Handles
                    </h2>
                  </div>
                  
                  <button
                    onClick={() => setOpen(false)}
                    className="text-[#205363] flex items-center border-[1px] border-[#205363] rounded-[10px] py-3 px-3 w-[89px] h-[40px]"
                  >
                    <span className=" text-[#205363] text-[12px] leading-[16.8px] mx-2">
                      Close
                    </span>
                    <svg
                      className="h-[16px] w-[16px] border-[1px] border-[#205363] rounded-full"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
                {/* Search Input */}
                {/* <div className="mt-4 px-4">
                    <input
                      type="text"
                      placeholder="Search post here"
                      className="w-full p-2 border border-gray-300 rounded-md focus:border-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 transition-colors duration-300"
                    />
                  </div>
                  <div className="mt-4 px-4">
                    <p className="ml-2 text-gray-400">Results</p>
                  </div> */}
                {/* Sidebar Content */}
                <div className="lg:mt-4 mt-0 px-4 z-1">
                  <div className="lg:mt-6 mt-3">
                    <section className="flex flex-col lg:mb-9 my-5">
                      <h4 className="text-[#828282] text-[14px] leading-[16.9px] font-[500] mb-3 ">
                        Twitter
                      </h4>
                      <div className="border-[1px] px-5 mt-2 border-[#B3BAC5] rounded-[8px]">
                        <EditInput
                          value={twitter}
                          onChange={(e) => setTwitter(e.target.value)}
                          placeholder="Edit Twitter Handle"
                          inputRef={twitterRef}
                          onFocus={() => setTwitterFocus(true)}
                        />
                      </div>
                    </section>
                    <section className="flex flex-col lg:mb-9 my-5">
                      <h4 className="text-[#828282] text-[14px] leading-[16.9px] font-[500] mb-3 ">
                        Instagram
                      </h4>
                      <div className="border-[1px] px-5 mt-2 border-[#B3BAC5] rounded-[8px]">
                        <EditInput
                          value={instagram}
                          onChange={(e) => setInstagram(e.target.value)}
                          placeholder="Edit Instagram Handle"
                          inputRef={instagramRef}
                          onFocus={() => setInstagramFocus(true)}
                        />
                      </div>
                    </section>
                    <section className="flex flex-col lg:mb-9 my-5">
                      <h4 className="text-[#828282] text-[14px] leading-[16.9px] font-[500] mb-3 ">
                        TikTok
                      </h4>
                      <div className="border-[1px] px-5 mt-2 border-[#B3BAC5] rounded-[8px]">
                        <EditInput
                          value={tiktok}
                          onChange={(e) => setTiktok(e.target.value)}
                          placeholder="Edit TikTok Handle"
                          inputRef={tiktokRef}
                          onFocus={() => setTiktokFocus(true)}
                        />
                      </div>
                    </section>
                    <section className="flex flex-col mb-9 ">
                      <h4 className="text-[#828282] text-[14px] leading-[16.9px] font-[500] mb-3 ">
                        Facebook
                      </h4>
                      <div className="border-[1px] px-5 mt-2 border-[#B3BAC5] rounded-[8px]">
                        <EditInput
                          value={facebook}
                          onChange={(e) => setFacebook(e.target.value)}
                          placeholder="Edit Facebook Handle"
                          inputRef={facebookRef}
                          onFocus={() => setFacebookFocus(true)}
                        />
                      </div>
                    </section>
                    {/* Update Button */}
                    <div className=" mb-5  absolute bottom-0  right-3 w-full flex items-end justify-end pt-7   ">
                      <Button
                        className="w-[161px] py-[13px] bg-primary-p300 text-light"
                        onClick={async () => {
                          await updateProfile();
                          await updateSocialMedia();
                        }}
                        label="Update"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </section>
          {/* Open sidebar button */}
          <button
          onClick={() => setOpen(true)}
          className="px-10 py-5 border-[1px] text-[#205363] lg:w-[159px] w-[120px] h-[46px]  leading-[14px] text-[13px] font-[500]  rounded-xl border-[#205363]"
        >
            Edit
          </button>
        </div>
      </div>
    </>
  );
};

export default SocialSideBar;
